export const translationOrganizations_sv_part1 = {
  // Shared actions and labels
  add: "Lägg till",
  attach: "Koppla",
  attaching: "Kopplar...",
  cancel: "Avbryt",
  chatbotPlural: "chatbotar",
  chatbotSingular: "chatbot",
  creating: "Skapar...",
  currentlyUnassigned: "För närvarande otilldelad",
  delete: "Ta bort",
  deleting: "Tar bort...",
  detach: "Koppla bort",
  detaching: "Kopplar bort...",
  edit: "Redigera",
  noDomainsConfigured: "Inga domäner konfigurerade",
  remove: "Ta bort",
  resend: "Skicka igen",
  save: "Spara",
  saving: "Sparar...",
  searchChatbotsPlaceholder: "Sök chatbotar…",
  searchOrganizationsPlaceholder: "Sök organisationer…",
  selectChatbotPlaceholder: "Välj chatbot",
  selectOrganizationPlaceholder: "Välj organisation",
  unableToAttachChatbot: "Det gick inte att koppla chatbot.",
  unableToDetachChatbot: "Det gick inte att koppla bort chatbot.",
  unassigned: "Otilldelad",
  // Organizations list page
  orgsHeaderTitleAdmin: "Hantera organisationer och chatbotar",
  orgsHeaderTitleOwner: "Hantera organisationsåtkomst",
  orgsHeaderDescriptionAdmin:
    "Administratörer kan skapa organisationer, skapa eller klona chatbot-ID:n och kontrollera chatbot-tilldelningar över alla organisationer. Ägare kan hantera medlemmar och inbjudningar för de organisationer de äger.",
  orgsHeaderDescriptionOwner: "Hantera medlemmar och inbjudningar för de organisationer du äger.",
  orgsUnableToLoadOrganizations: "Det gick inte att ladda organisationer.",
  orgsOrganizationCreated: "Organisation skapad.",
  orgsOrganizationDeleted: 'Organisation "{name}" togs bort.',
  orgsUnableToCreateOrganization: "Det gick inte att skapa organisation.",
  orgsEyebrow: "Organisationer",
  orgsTabOrganizations: "Organisationer",
  orgsTabChatbots: "Chatbotar",
  orgsSearchPlaceholder: "Sök organisationer, domäner eller tilldelade chatbot-ID:n",
  orgsCreateOrganization: "Skapa organisation",
  orgsCreateDialogTitle: "Skapa organisation",
  orgsCreateDialogDescription:
    "Nya organisationer startar utan medlemmar eller chatbotar. Du kan bjuda in ägare och koppla chatbotar efteråt.",
  orgsOrganizationNameLabel: "Organisationsnamn",
  orgsOrganizationNamePlaceholder: "Acme Support",
  orgsDomainsLabel: "Domäner",
  orgsDomainsPlaceholder: "acme.com, help.acme.com",
  orgsInviteRedirectUrlLabel: "Omdirigerings-URL för inbjudan",
  orgsInviteRedirectUrlHelp:
    "Användare som accepterar inbjudningar eller slutför registrering skickas hit. Använd en godkänd HTTPS-instrumentpanels-URL.",
  orgsInviteRedirectUrlPlaceholder: "https://dashboard.askdiverge.ai",
  orgsCreate: "Skapa",
  orgsShowingCount: "Visar {shown} av {total} organisationer",
  orgsForSearch: 'för "{search}"',
  orgsLoadingOrganizationsAria: "Laddar organisationer",
  orgsLoadingOrganizations: "Laddar organisationer...",
  orgsEmptyNoMatches: "Inga organisationer matchade din sökning.",
  orgsEmptyAdmin:
    "Inga organisationer hittades ännu. Skapa den första organisationen för att komma igång.",
  orgsEmptyOwner: "Inga hanterbara organisationer hittades.",
  orgsAdminAccess: "Administratörsåtkomst",
  orgsOwnerAccess: "Ägaråtkomst",
  orgsMemberSingular: "Medlem",
  orgsMemberPlural: "Medlemmar",
  orgsOwnerSingular: "Ägare",
  orgsOwnerPlural: "Ägare",
  orgsInviteSingular: "Inbjudan",
  orgsInvitePlural: "Inbjudningar",
  orgsAllOrganizationsLoaded: "Alla organisationer laddade.",
  orgsLoadingMoreOrganizations: "Laddar fler organisationer",
  // Chatbot management panel
  botMgmtUnableToLoadChatbots: "Det gick inte att ladda chatbotar.",
  botMgmtChatbotCloned: "Chatbot klonad. Den är för närvarande otilldelad.",
  botMgmtChatbotCreated: "Chatbot skapad. Den är för närvarande otilldelad.",
  botMgmtUnableToCreateChatbot: "Det gick inte att skapa chatbot.",
  botMgmtSelectOrgBeforeAttach: "Välj en organisation innan du kopplar en chatbot.",
  botMgmtAttachedTo: "Kopplade {chatbotId} till {organizationName}.",
  botMgmtDetached: "Kopplades bort {chatbotId}.",
  botMgmtDetachChatbotTitle: "Koppla bort {chatbotId}?",
  botMgmtDetachChatbotWarning:
    "Organisationens medlemmar förlorar åtkomsten till chatboten. Dess inställningar, AI-konversationer och kontaktformulär behålls; dess livechatthistorik och -inställningar, Chatbot API-formulär, webhook-händelser, agenttestsviter och -arbetsytor samt butiksmedlemskap tas bort.",
  botMgmtDetachChatbotConfirm: "Koppla bort chatbot",
  botMgmtDeleteChatbotTitle: "Ta bort chatbot {chatbotId}?",
  botMgmtDeleteChatbotWarning:
    "Detta tar permanent bort chatboten, inklusive inställningar, konversationer och uppgifter. Detta kan inte ångras.",
  botMgmtDeleteChatbotConfirm: "Ta bort chatbot",
  botMgmtChatbotDeleted: "Tog bort {chatbotId}.",
  botMgmtUnableToDeleteChatbot: "Det gick inte att ta bort chatbot.",
  botMgmtEyebrow: "Chatbotar",
  botMgmtHeading: "Skapa, klona och tilldela chatbot-ID:n",
  botMgmtIntro:
    "Skapa tomma chatbotar eller klona en befintlig chatbot-konfiguration. Varje chatbot kan bara kopplas till en organisation åt gången.",
  botMgmtStatTotal: "totalt",
  botMgmtStatUnassigned: "otilldelade",
  botMgmtNewChatbotId: "Nytt chatbot-ID",
  botMgmtChatbotIdPlaceholder: "support-bot-eu",
  botMgmtCreationMode: "Skapningsläge",
  botMgmtSelectMode: "Välj läge",
  botMgmtModeBlank: "Tom",
  botMgmtModeClone: "Klona befintlig",
  botMgmtSourceChatbot: "Källchatbot",
  botMgmtCreateHelper:
    "Nya chatbot-ID:n skapas otilldelade. Koppla dem till en organisation nedan när det behövs.",
  botMgmtCreateChatbot: "Skapa chatbot",
  botMgmtCatalogTitle: "Katalog",
  botMgmtCatalogDescription:
    "Otilldelade chatbotar kan kopplas till en organisation. Tilldelade chatbotar måste kopplas bort innan de kan flyttas.",
  botMgmtLoadingChatbotsAria: "Laddar chatbotar",
  botMgmtLoadingChatbots: "Laddar chatbotar...",
  botMgmtNoChatbotsFound: "Inga chatbotar hittades ännu.",
  botMgmtAssignedTo: "Tilldelad till {organization}",
  // Organization detail page
  orgDetailTabMembers: "Medlemmar",
  orgDetailTabInvitations: "Inbjudningar",
  orgDetailTabSettings: "Inställningar",
  orgDetailTabChatbots: "Chatbotar",
  orgDetailTabBrands: "Varumärken",
  orgDetailTabBusiness: "Affärsmässigt",
  orgDetailBackToOrganizations: "Tillbaka till organisationer",
  orgDetailLoadingOrganization: "Laddar organisation...",
  orgDetailAdminView: "Administratörsvy",
  orgDetailOwnerView: "Ägarvy",
  orgDetailUnableToLoadOrganization: "Det gick inte att ladda organisation.",
};
